exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-168b093a] {\n  /* 确保 MindAR 目标有足够的大小 */\n  width: 100%;\n  height: 100%;\n  background: #000000;\n}\n", ""]);

// exports
